import React, { useState } from "react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";
import useSeo from "../hooks/useSeo";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  useSeo({
    title: "Contact · Delivery, Returns & Team Enquiries",
    description: "Get in touch with Pritch. Questions on sizing, orders, returns or team enquiries.",
    path: "/contact",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitContact(form);
      toast.success("Message received. We'll come back within 2 working days.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="bg-chalk">
      <section className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="overline mb-4">Contact</p>
          <h1 className="font-display uppercase text-5xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
            Get in <br />
            <span className="text-mute">touch.</span>
          </h1>
          <p className="mt-6 max-w-md text-mute leading-relaxed">
            Questions on sizing, orders, returns or team enquiries — drop a note below or email
            directly.
          </p>
          <div className="mt-10 space-y-4 text-sm">
            <div>
              <p className="overline mb-1">Email</p>
              <p>hello@pritch.fc</p>
            </div>
            <div>
              <p className="overline mb-1">Delivery</p>
              <p className="text-mute">UK 2–4 days · EU 5–8 days · Free over £40</p>
            </div>
            <div>
              <p className="overline mb-1">Returns</p>
              <p className="text-mute">30-day returns in original condition</p>
            </div>
          </div>
        </div>

        <div className="md:col-span-7 bg-white border border-line p-6 md:p-10">
          <form onSubmit={onSubmit} className="space-y-5" data-testid="contact-form">
            <div>
              <label className="overline block mb-2">Name</label>
              <input
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
                data-testid="contact-form-name"
              />
            </div>
            <div>
              <label className="overline block mb-2">Email</label>
              <input
                required
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
                data-testid="contact-form-email"
              />
            </div>
            <div>
              <label className="overline block mb-2">Message</label>
              <textarea
                required
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
                data-testid="contact-form-message"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="contact-form-submit"
            >
              {loading ? "Sending…" : "Send message"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
